// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { FormInputWrapper } from "@insite/mobius/FormField";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { productActionsStyle } from "@synd/App/Components/Product/ProductActions";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { css } from "styled-components";

productActionsStyle.wrapper = {
    css: css`
        display: grid;
        grid-template-columns: minmax(97px, auto) minmax(0, 1fr);
        width: 100%;
        gap: 8px;
    `,
};
productActionsStyle.viewButton = {
    sizeVariant: "small",
    css: css`
        flex-grow: 1;
        white-space: nowrap;
    `,
    typographyProps: {
        size: 11,
        lineHeight: "16px",
    },
};
productActionsStyle.addToCartButtonWrapper = {
    css: css`
        flex-grow: 1;
    `,
};

productActionsStyle.productAddToCartButtonStyles = {
    sizeVariant: "small",
    css: css`
        width: 100%;
        white-space: nowrap;
    `,
    typographyProps: {
        size: 11,
        lineHeight: "16px",
    },
};

productActionsStyle.uomSelectWrapper = {
    css: css`
        flex-grow: 1;
    `,
};

productActionsStyle.unitOfMeasureSelect = {
    sizeVariant: "small",
    cssOverrides: {
        formField: css`
            margin-top: 0;
        `,
    },
    labelProps: {
        css: css`
            display: none;
            &&& + ${FormInputWrapper} {
                margin-top: 0;
            }
        `,
    },
};

productActionsStyle.multipleSaleQty = {
    css: css`
        width: 100%;
        &:has(> div:empty) {
            display: none;
        }
        > div {
            width: 100%;
        }
    `,
};

productActionsStyle.qtyWrapper = {
    css: css`
        display: flex;
    `,
};

productActionsStyle.productQuantityOrdered = {
    select: {
        sizeVariant: "small",
        cssOverrides: {
            formField: css`
                min-width: 47px;
            `,
        },
    },
};
productActionsStyle.buttonsWrapper = {
    css: css`
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 8px;
    `,
};

productActionsStyle.signInButton = {
    sizeVariant: "small",
};

productActionsStyle.registerButton = {
    variant: "secondary",
    sizeVariant: "small",
};
productActionsStyle.notify = {
    css: css`
        width: 100%;
        border: 0;
        border-radius: 8px;
        padding: 6px;
        ${IconWrapper}, svg {   
            width: 12px;
            height: 13px;
        }
        ${IconWrapper} {
            margin: 0 6px 0 0;
        }
            
        &, ${TypographyStyle} {
            font-size: ${fontConfig.xxSmallSingleLine.size}px;
            line-height: ${fontConfig.xxSmallSingleLine.lineHeight};
        }
    `,
};
